// extracted by mini-css-extract-plugin
module.exports = {"text-block":"text-block_text-block__e2oF8","text-block__container":"text-block_text-block__container__DYMXc","text-block--full-bleed":"text-block_text-block--full-bleed__yfVcT"};